import { hasOwn, isEmpty } from '@pexip/utils';
import { GUID_MIN_LENGTH } from './constants';
export const isUndefined = (t) => typeof t === 'undefined';
export const isNull = (t) => typeof t === 'object' && !t;
export const isNotUndefined = (t) => !isUndefined(t) && !isNull(t);
export const isSSOdMessage = (e) => {
    if (typeof e !== 'object') {
        return false;
    }
    if (e === null) {
        return false;
    }
    if ('result' in e && ('token' in e || 'code' in e)) {
        return true;
    }
    return false;
};
const RTC_PRIORITY = ['very-low', 'low', 'medium', 'high'];
export const isMediaPriority = (e) => {
    if (!e || typeof e !== 'object') {
        return false;
    }
    if (hasOwn(e, 'video') && hasOwn(e, 'audio') && hasOwn(e, 'presentation')) {
        return !Object.values(e).some(e => !RTC_PRIORITY.includes(e));
    }
    return false;
};
export const isJitterBufferTarget = (e) => {
    if (!e || typeof e !== 'object') {
        return false;
    }
    if (isEmpty(e)) {
        return true;
    }
    else if (hasOwn(e, 'video') ||
        hasOwn(e, 'audio') ||
        hasOwn(e, 'presentation')) {
        return !Object.values(e).some(e => typeof e !== 'number' && typeof e !== 'object' && !e);
    }
    return false;
};
export function isRoomID(id) {
    if (id && (id === 'main' || id.trim().length >= GUID_MIN_LENGTH)) {
        return true;
    }
    return false;
}
// Assert cannot be arrow function: https://github.com/microsoft/TypeScript/issues/34523
export function assertRoomID(id) {
    if (!isRoomID(id)) {
        throw new Error('Invalid RoomID');
    }
}
export function isParticipantID(id) {
    if (id && id.trim().length >= GUID_MIN_LENGTH) {
        return true;
    }
    return false;
}
export function assertParticipantID(id) {
    if (!isParticipantID(id)) {
        throw new Error('Invalid ParticipantID');
    }
}
